import { createService } from '@/helpers/hasura'

import gql from 'graphql-tag'

import {
  CartItemFragment,
  AddressFragment,
  FileFragment
} from '@/helpers/api/fragments'

const output = `
  ...CartItem
  product {
    code
    short_description
    allow_grouping
    custom_form
  }
  customer {
    legal_name
  }
  user {
    name
  }
  file {
    ...File
  }
  shipping_address{
    ...Address
  }
`
const fragments = gql`
  ${CartItemFragment}
  ${AddressFragment}
  ${FileFragment}
`

const allowedFields = [
  'customer_id',
  'user_id',
  'quantity',
  'specifications',
  'product_id',
  'reference',
  'file_id',
  'shipping_address_id',
  'comments',
  'updated_at',
  'created_at'
]

export default config => {
  const { client } = config
  const service = createService({
    ...config,
    table: 'cart_item',
    defaultFilters: [],
    defaultOutput: output,
    defaultFragments: fragments,
    defaultSearchBy: [
      'reference',
      { product: ['code', 'short_description'] },
      { shipping_address: ['city', 'company_name'] },
      { file: ['file_name'] }
    ],
    allowedFields
  })

  return {
    ...service,
    cartItemByUserIdSubscription: payload => {
      /*const {
        user_id = () => {
          throw new Error("cartItemByUserIdSubscription: 'user_id' is required")
        }
      } = payload*/

      /*

      const query = gql`
        subscription items($userId: uuid!){
          items: cart_item(where : { user_id: { _eq: $userId}){
            ${output}
          }
        }
        ${fragments}
      `

      const observer = client.subscribe({
        query,
        variables: {
          userId: user_id
        }
      })*/

      return null
    }
  }
}
